// department.repo.ts

import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { Department } from "../../entities/department-entity";

@Injectable()
export class DepartmentRepo {
    constructor(
        @InjectRepository(Department)
        private repo: Repository<Department>
    ) { }

    async findOne(options: any): Promise<Department | null> {
        return this.repo.findOne(options);
    }

    async find(options?: any): Promise<Department[]> {
        return this.repo.find(options);
    }

    async save(entity: Department): Promise<Department> {
        return this.repo.save(entity);
    }
}